module.exports = __webpack_public_path__ + "static/media/icon_cube_molecule.aefc7c82.svg";